import { useQuery } from "@tanstack/react-query";
import { albumsOfType, loadAlbums, type AlbumDevice } from "../../apis";

/**
 * Active albums from /album/load, keyed by album_type.
 *
 * @param albumDevice scopes to /album/load/mobile or /album/load/desktop
 * @see loadAlbums — unscoped, the grouping happens client-side
 */
export function useAlbums(albumDevice?: AlbumDevice) {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["albums", albumDevice ?? "all"],
    queryFn: () => loadAlbums(albumDevice),
  });

  return {
    albums: data,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
}

/** The active albums of one album_type, e.g. "home" or "how to". */
export function useAlbumsByType(albumType: string, albumDevice?: AlbumDevice) {
  const { albums, ...rest } = useAlbums(albumDevice);

  return { albums: albumsOfType(albums, albumType), ...rest };
}
